import useAuthenticatedMutation from '../useAuthenticatedMutation';
import PropTypes from 'prop-types';
import axios from 'axios';
import { API_BASE_URL, FUNCTION_KEY, PROJECT_SCOPE } from '../../../config';
import logError from '../../metadata/ErrorLogging';

// Function to perform HTTP requests
const manageProjectTestType = async ({data, method}, token) => {
    let url = `${API_BASE_URL}disqoadmin/project_test_type`;

    if (method === 'DELETE' && data.api_id) {
        url += `?api_id=${data.api_id}`; // Add to URL for DELETE
    }

    try {
        const response = await axios({
            method: method,
            url: url,
            headers: {
                'Authorization': `Bearer ${token}`,
                'x-functions-key': FUNCTION_KEY,
            },
            data: method !== 'DELETE' ? data : {}, // Only send data for non-DELETE requests
        });

        return response.data;
    } catch (error) {
        logError(`Failed to ${method.toLowerCase()} project test type:`, error, {});
        throw error;
    }
};

// Hook to manage organisations
export default function useProjectTestTypeManager(onSuccess, onError) {
    
    const projectScope = [PROJECT_SCOPE];
    const { mutate, isLoading, isError, error, data, reset: resetMutation } = useAuthenticatedMutation(manageProjectTestType, projectScope, {
        onSuccess,
        onError
    });

    // Function to call the mutate function with additional parameters for different HTTP methods
    const performAction = (data, method = 'POST') => {
        return new Promise((resolve, reject) => {
            mutate(
                { data, method },
                {
                    onSuccess: (result) => {
                        resolve(result);
                        if (onSuccess) onSuccess(result);
                    },
                    onError: (error) => {
                        reject(error);
                        if (onError) onError(error);
                    },
                }
            );
        });
    };

    return {
        performAction,
        isLoading,
        isError,
        projectTestTypeError: error,
        data,
        reset: resetMutation
    };
}

useProjectTestTypeManager.propTypes = {
    onSuccess: PropTypes.func,
    onError: PropTypes.func
}